import React from "react";
import { Container, Row, Col } from "reactstrap";
import PermissionList from "./PermissionList";

const Permissions = () => {
  return (
    <Container fluid className="p-0">
      <h1 className="page-title">Permissions</h1>
      <Row>
        <Col lg="12" className="d-flex">
          <PermissionList />
        </Col>
      </Row>
    </Container>
  );
};

export default Permissions;
